export const QUOTE_STATUSES = {
  ARCHIVED: "QuoteArchived",
  BOUND: "QuoteBound",
  NOT_TAKEN_UP: "QuoteNotTakenUp",
  SUBMITTED: "QuoteSubmitted",
};

export default QUOTE_STATUSES;
